<template>
  <div class="nav-wrap">
    <main>
      <div class="nav-box c-flex-space-between c-flex-align-center">
        <div class="c-flex c-flex-align-center nav-title-box">
          <img
            alt="logo"
            class="logo-img"
            src="~@/assets/img/images/logo-black.png"
          />
          <div
            :class="{
              sel: currRouterPath === '/' || currRouterPath === '/home',
            }"
          >
            <router-link to="/home"> {{ $t("nav.home") }}</router-link>
          </div>
          <div
            :class="{
              sel: currRouterPath === '/mall',
            }"
          >
            <router-link to="/mall">{{ $t("nav.mall") }}</router-link>
          </div>
          <div
            :class="{
              sel: currRouterPath === '/ctc',
            }"
          >
            <router-link to="/ctc"> {{ $t("nav.ctc") }}</router-link>
          </div>
          <div
            :class="{
              sel: currRouterPath === '/question',
            }"
          >
            <router-link to="/question">{{ $t("nav.faq") }}</router-link>
          </div>
          <div
            :class="{
              sel: currRouterPath === '/partner',
            }"
          >
            <router-link to="/partner">{{
              $t("nav.partner")
            }}</router-link>
          </div>
        </div>
        <div class="c-flex c-flex-align-center nav-title-box">
          <div>
            <router-link :to="{ path: '/user', query: { type: 5 } }">{{
              $t("nav.order")
            }}</router-link>
          </div>
          <div
            :class="{
              sel: currRouterPath === '/wallet',
            }"
          >
            <router-link to="/wallet">{{ $t("nav.assets") }}</router-link>
          </div>
          <div>
            <router-link to="/download">
              <img
                alt="news"
                class="nav-item-img-padding"
                v-if="currRouterPath === '/download'"
                src="~@/assets/img/images/nav/download-s.png"
              />
              <img
                alt="news"
                v-else
                class="nav-item-img-padding"
                src="~@/assets/img/images/nav/download.png"
              />
            </router-link>
          </div>
          <div @mouseenter="showTooltip" @mouseleave="handleMouseLeave">
            <img
              alt="news"
              class="nav-item-img"
              src="~@/assets/img/images/nav/news.png"
            />
          </div>
          <div>
            <el-popover
              trigger="hover"
              placement="bottom"
              popper-class="popper-more-btn"
            >
              <div class="lag-box">
                <div
                  :class="{
                    sel: appLan === 'en-us',
                  }"
                  @click="appLanClick('en-us')"
                >
                  English
                </div>
                <div
                  :class="{
                    sel: appLan === 'zh-hk',
                  }"
                  @click="appLanClick('zh-hk')"
                >
                  繁体中文
                </div>
                <div
                  :class="{
                    sel: appLan === 'zh-cn',
                  }"
                  @click="appLanClick('zh-cn')"
                >
                  简体中文
                </div>
                <div
                  :class="{
                    sel: appLan === 'vi-vn',
                  }"
                  @click="appLanClick('vi-vn')"
                >
                  Tiếng Việt
                </div>
              </div>
              <img
                alt="news"
                slot="reference"
                class="nav-item-img"
                src="~@/assets/img/images/nav/netword.png"
              />
            </el-popover>
          </div>
          <!-- <div>
            <router-link to="/wallet">
              <img
                alt="news"
                class="nav-item-img"
                v-if="currRouterPath === '/wallet'"
                src="~@/assets/img/images/nav/wallet-s.png"
              />
              <img
                alt="news"
                v-else
                class="nav-item-img"
                src="~@/assets/img/images/nav/wallet.png"
              />
            </router-link>
          </div> -->
          <div>
            <template v-if="!jwtToken">
              <router-link to="/login">
                {{ $t("nav.login") }}
              </router-link>
            </template>
            <template v-if="jwtToken">
              <router-link to="/user">
                <div
                  :class="{
                    sel: currRouterPath === '/user',
                  }"
                  class="c-flex-align-center"
                >
                  <img
                    alt="news"
                    class="nav-item-img"
                    v-if="currRouterPath === '/user'"
                    src="~@/assets/img/images/icon/user-s.png"
                  />
                  <img
                    alt="news"
                    v-else
                    class="nav-item-img"
                    src="~@/assets/img/images/icon/user.png"
                  />
                  <span style="margin-left: 10px"> {{ $t("nav.mine") }}</span>
                </div>
              </router-link>
            </template>
          </div>
        </div>
        <div
          class="news-popup-box"
          v-if="isVisible"
          ref="tooltip"
          @mouseenter="handleTooltipEnter"
          @mouseleave="handleTooltipLeave"
        >
          <div class="tab-box">
            <!-- <div
              :class="{ sel: currTab === 'system_notice' }"
              @click="tabChange('system_notice')"
            >
              {{ $t("nav.ann_drop.system") }}
            </div> -->
            <div
              :class="{ sel: currTab === 'platform_notice' }"
              @click="tabChange('platform_notice')"
            >
              {{ $t("nav.ann_drop.ann") }}
            </div>
            <div
              :class="{ sel: currTab === 'news' }"
              @click="tabChange('news')"
            >
              {{ $t("nav.ann_drop.news") }}
            </div>
          </div>
          <div v-if="newsList.length <= 0" class="no-data-box1">~空~</div>
          <div
            v-else
            class="news-item"
            v-for="(item, index) in newsList"
            @click="itemClick(item)"
          >
            <div class="dot" />
            <div>
              <p class="p1">{{ item.title }}</p>
              <p class="p2">
                {{
                  dateFormatter(
                    new Date(item.createTime),
                    "yyyy-MM-dd hh:mm:ss",
                  )
                }}
              </p>
            </div>
          </div>
          <div class="news-more" @click="$router.push({ path: '/news' })">
            {{ $t("nav.ann_more") }}
            <i class="el-icon-arrow-right"></i>
          </div>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import { mapState } from "vuex";
import bus from "@/assets/js/bus";

export default {
  name: "v-nav",
  data() {
    return {
      newsList: [],
      currTab: "platform_notice", // 焦点图：banner、新闻：news、系统通知：system_notice，平台公告：platform_notice、个人消息：personal_notice、常见问题：question
      currRouterPath: "/",
      isVisible: false,
      tooltipContent: "",
      tooltipStyle: {},
      hideTimeout: null,
      leaveDelay: 300, // 延迟隐藏时间
      ann_show: false,
      lan_show: false,
      userDropFlag: false,
      navChoice: 0,
      hasNoRead: false,
      annData: [],
      systemData: [],
      notifyTimer: null,
    };
  },
  watch: {
    $route(to, from) {
      this.currRouterPath = to.path;
    },
  },
  created() {
    this.getNotifyTexts();
    bus.$on("updateSystemData", () => {
      this.getNewsList();
    });
    //每10秒拉去一次系统通知
    this.notifyTimer = setInterval(() => {
      if (this.user.username && window.localStorage.getItem("jwt-token")) {
        this.getNewsList();
      }
    }, 10000);
  },
  mounted() {
  },
  beforeUnmount() {
    clearTimeout(this.hideTimeout);
  },
  methods: {
    appLanClick(val) {
      this.$i18n.locale = val;
      this.$store.commit("updateAppLan", val);
	  this.$router.go(0);// 強制刷新頁面
    },
    itemClick(item) {
      this.$router.push({
        path: "/newsDetail",
        query: { id: item.articleId },
      });
    },
    getNewsList() {
      const _this = this;
      this.$axios
        .post("/cms/getList", {
          page: 0,
          rows: 2,
          cateCode: this.currTab,
        })
        .then((res) => {
          if (res.data.code === this.errorCode.ok) {
            _this.newsList = res.data.data.rows || [];
          }
        });
    },
    showTooltip(event) {
      clearTimeout(this.hideTimeout);
      this.isVisible = true;
      // 防止重绘导致的闪烁
      this.$nextTick(() => {
        this.positionTooltip(event);
      });
    },
    positionTooltip(event) {
      const tooltipEl = this.$refs.tooltip;
      if (!tooltipEl) return;

      const x = event.clientX;
      const y = event.clientY;
      const margin = 10; // 与鼠标的间距

      // 获取视口尺寸
      const viewportWidth = window.innerWidth;
      const viewportHeight = window.innerHeight;

      // 获取提示框尺寸
      const tooltipRect = tooltipEl.getBoundingClientRect();

      // 计算位置（防止超出视口）
      let left = x + margin;
      let top = y + margin;

      if (left + tooltipRect.width > viewportWidth) {
        left = x - tooltipRect.width - margin;
      }

      if (top + tooltipRect.height > viewportHeight) {
        top = y - tooltipRect.height - margin;
      }

      this.tooltipStyle = {
        left: `${left}px`,
        top: `${top}px`,
        position: "fixed",
        zIndex: 9999,
      };
    },
    handleMouseLeave() {
      // 设置延迟隐藏
      this.hideTimeout = setTimeout(() => {
        if (!this.isHoveringTooltip) {
          this.isVisible = false;
        }
      }, this.leaveDelay);
    },
    handleTooltipEnter() {
      clearTimeout(this.hideTimeout);
      this.isHoveringTooltip = true;
    },
    handleTooltipLeave() {
      this.isHoveringTooltip = false;
      this.hideTimeout = setTimeout(() => {
        this.isVisible = false;
      }, this.leaveDelay);
    },
    tabChange(val) {
      this.currTab = val;
      this.getNewsList();
    },
    newsmouseleave() {
      setTimeout(() => {
        this.newsShow = false;
      }, 1500);
    },
    loginOut() {
      this.$store.dispatch("actions_loginOut").then((res) => {
        this.$router.push({ path: "/" });
      });
    },
    //官方公告
    getNotifyTexts() {
      this.$axios.post("/HomePage/notifyTexts", {}).then((res) => {
        if (res.data.code === this.errorCode.ok) {
          this.annData = res.data.data;
        }
      });
    },
    //系统通知
    // getSystemData() {
    //   this.$axios
    //     .post("/notify/getMessageNotify", { page: 1, rows: 4 })
    //     .then((res) => {
    //       this.systemData = res.data.data.rows;
    //       let read = false;
    //       this.systemData.forEach((value) => {
    //         if (value.readStatus === 0) {
    //           read = true;
    //         }
    //       });
    //       this.hasNoRead = read;
    //     });
    // },
    getJump(item) {
      let url = "";
      switch (item.contentType) {
        case "withdraw":
          url = "/userAssets/tradeRecord?tagShow=withdraw";
          break;
        case "deposit":
          url = "/userAssets/tradeRecord?tagShow=recharge";
          break;
        case "rebate":
          url = "/userAssets/tradeRecord?tagShow=other";
          break;
        case "burstBlock":
          url = "/userAssets/blockDetail?id=" + item.jumpInfo.id;
          break;
        case "otc":
          url =
            "/otc/otcOrderConfirm?otcType=" +
            item.jumpInfo.side +
            "&identity=" +
            item.jumpInfo.queryType +
            "&otcOrderId=" +
            item.jumpInfo.orderId;
          break;
        default:
          url = "#";
          break;
      }
      if (item.readStatus === 0) {
        this.$axios.post("/notify/setRead", { ids: [item.id] }).then((res) => {
          if (res.data.code === this.errorCode.ok) {
            this.getSystemData();
          }
        });
      }
      this.$router.push({ path: url });
    },
  },
  computed: {
    ...mapState(["user", "errorCode", "appLan", "jwtToken"]),
  },
};
</script>

<style lang="less" scoped>
.nav-wrap {
  top: 0;
  z-index: 999;
  height: 120px;
  position: sticky;
  padding-left: 260px;
  padding-right: 260px;
  background: #ffffff;
  main {
    height: 100%;
    .nav-box {
      width: 100%;
      height: 100%;
      position: relative;
      .logo-img {
        height: 48px;
        width: 180px;
      }
      .nav-title-box {
        font-size: 20px;
        font-weight: 400;
        color: #333333;
        font-family: PingFang SC, PingFang SC;
        .sel {
          color: #4063ff;
          font-weight: 800;
        }
        a {
          display: flex;
          align-items: center;
        }
        div {
          display: flex;
          cursor: pointer;
          margin-left: 40px;
          align-items: center;
        }
        div:first-child {
          margin-left: 0px;
        }
      }
    }
  }
}
.nav-item-img {
  width: 34px;
  height: 34px;
}
.nav-item-img-padding {
  width: 30px;
  height: 30px;
}

.news-popup-box {
  padding: 20px;
  top: 140px;
  right: 0px;
  max-width: 500px;
  position: absolute;
  background: #ffffff;
  border-radius: 12px 12px 12px 12px;
  .tab-box {
    gap: 40px;
    display: flex;
    margin-bottom: 10px;
    border-bottom: 1px solid #e2e3e3;
    div {
      padding-bottom: 20px;
      cursor: pointer;
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 16px;
      color: #666666;
    }
    .sel {
      font-weight: 800;
      font-size: 16px;
      color: #4063ff;
      position: relative;
    }
    .sel::before {
      content: "";
      position: absolute;
      display: block;
      left: 0;
      width: 100%;
      bottom: 0;
      border-bottom: 1px solid #4063ff;
    }
  }
  .news-more {
    cursor: pointer;
    text-align: end;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 12px;
    color: #4063ff;
  }
  .news-item {
    gap: 12px;
    display: flex;
    margin-top: 10px;
	cursor: pointer;
    .dot {
      width: 8px;
      height: 8px;
      margin-top: 10px;
      border-radius: 50%;
      background: #f04545;
    }
    .p1 {
      font-family: PingFang SC, PingFang SC;
      font-weight: bold;
      font-size: 16px;
      color: #666666;
    }
    .p2 {
      margin-top: 4px;
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 13px;
      color: #999999;
    }
  }
}
.no-data-box1 {
  margin: 20px auto;
  text-align: center;
  font-size: 12px;
  color: #999999;
}
/deep/.el-popover__reference-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
}
.lag-box {
  div {
    cursor: pointer;
    margin-top: 4px;
  }
  .sel {
    color: #4063ff;
  }
  text-align: center;
}
</style>
